(function () {

    'use strict';

    angular.module('Services').factory('ServiceProfileTableService', ServiceProfileTableService);

    ServiceProfileTableService.$inject = [
        'Carrier',
        'TableLiteFactory',
        '$location',
        '$q',
        'toastr',
        '$filter',
        '$rootScope',
        'PermissionHelpers',
        'AdminPermissionService',
        '$uibModal'
    ];

    function ServiceProfileTableService(
        Carrier,
        TableLiteFactory,
        $location,
        $q,
        toastr,
        $filter,
        $rootScope,
        PermissionHelpers,
        AdminPermissionService,
        $uibModal
    ) {
        return function (services, carrierProfileId, carrierProfileName) {
            var carrierProfile = carrierProfileId;
            let selectedCarrierProfile = null;
            let defaultFilters = {};

            let serviceHeader = {
                label: 'SERVICE',
                viewName: 'serviceName',
                filterName: 'serviceId',
                sortName: 'serviceName',
                filter: {
                    type: 'select2',
                    placeholder: 'Search',
                    viewName: 'name',
                    filterBy: 'id',
                    items: services, //List of items shown in dropdown
                    onSubmit: function (header) {
                        sendRequest(angular.extend(evaluateFilter(header), {
                            carrierId: angular.getObjVal(header, 'filter.model.carrierId')
                        }));
                    }
                },
                headerFn: function () {
                    sort(this.sortName);
                }
            };
            var tableStructure = {
                tableName: 'CarrierServiceProfilesTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary pull-left',
                        label: 'ADD A SERVICE PROFILE',
                        tooltip: 'Click to Create new Service Profile',
                        onClick: function () {
                            $location.path('/carriers/service-profiles/new').search({ carrierProfileId: carrierProfile, carrierProfileName: carrierProfileName });
                        }
                    }, {
                        class: 'btn-quirk btn-success pull-left',
                        label: 'Create margin',
                        tooltip: 'Click to Create margin',
                        onClick: function () {

                            const selectedData = tableStructure.data.filter(serviceProfile => serviceProfile.isSelected);

                            if (!selectedData.length) {
                                toastr.warning('Select one Service Profile', 'Multiple Service Profile Selected');
                                return;
                            }
                            // add modal
                            var modalInstance = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                windowClass: 'full-height-modal',
                                templateUrl: '/templates/pages/services/modal/create-margin-modal.html',
                                controller: 'CreateMarginModalController',
                                controllerAs: 'vm',
                                size: 'md',
                                appendTo: $('body'),
                                resolve: {
                                    serviceProfileIds: () => {
                                        return selectedData
                                    }
                                }
                            });
                            modalInstance.result.then(function (data) {
                            }, function () {
                            });
                        }
                    }],

                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: false
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    width: '10',
                    filter: {
                        type: 'checkbox'
                    }
                },
                {
                    label: 'DISPLAY NAME IN QUOTES',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header))
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                {
                    label: 'CARRIER PROFILE NAME',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.name',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            selectedCarrierProfile = this.model;
                            sendRequest(evaluateFilter(header));
                            serviceHeader.filter.items = header.filter.model.carrier.services;
                        },
                        refreshOnLoad: true,
                        refresh: function (model) {
                            const defer = $q.defer();
                            let selected = this.model;
                            let filterItems = this.items;

                            Carrier.carrierProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    if (profile.id === carrierProfileId) {
                                        selected.name = profile.name;
                                        tableStructure.optionAddOns.select.model = profile;
                                        carrierProfileId = null;
                                    }
                                    filterItems.push(profile);
                                    filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                });
                                defer.resolve();
                            }, (error) => {
                                toastr.error('Unable to fetch carrier profiles', error.message);
                                defer.reject();
                            }, { size: 10, name: model ? model : '' });
                            return defer.promise;
                        },
                        model: carrierProfileId ? { name: ' ' } : null
                    },
                    headerFn: function () {
                        sort(this.sortName);
                    }
                },
                    serviceHeader,
                {
                    label: 'CARRIER ACCOUNT CODE',
                    viewName: 'carrierCode',
                    filterName: 'carrierAccountCode',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header))
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                {
                    label: 'FUEL LEVY',
                    viewName: 'currentFuelLevy'
                },
                {
                    label: 'MARGIN FIXED',
                    viewName: 'marginFixed'
                },
                {
                    label: 'MARGIN (%)',
                    viewName: 'marginPercent'
                },
                {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model === 'Enabled') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },
                {
                    label: 'Networking Enabled',
                    viewName: 'networkEffect',
                    filterName: 'networkEffectEnabled',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Enabled', 'Disabled'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model === 'Enabled') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }
                ],
                data: [],
                onInit: function () {
                    let profileId = carrierProfileId;
                    if (carrierProfileId) {
                        sendRequest({ carrierProfileId: profileId });
                    }
                    sendRequest({});
                },
                resetFilters: function () {
                    selectedCarrierProfile = null;
                    serviceHeader.filter.items = services;
                    delete tableActions.activeFilters.carrierId;
                    resetFilters();
                }
            };
            setIsHideRatesEngine();

            // add hide rates engine

            function setIsHideRatesEngine() {
                AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                    const moduleAccess = [];
                    success.content.forEach(user => {
                        user.modules.forEach(module => {
                            moduleAccess.push(module.name);
                        });
                    });
                    const isHideRatesEngine = PermissionHelpers.isHideRatesEngine(moduleAccess);
                    if (!isHideRatesEngine) {
                        tableStructure.optionAddOns.switcher = {
                            viewOwnProfiles: true,
                            onChange: function (evt) {
                                let switcher = this;
                                if (switcher.viewOwnProfiles) {
                                    defaultFilters = {
                                        isOwned: true,
                                        isConnected: false,
                                        isResellerNetwork: false,
                                        isReceived: false
                                    };
                                } else {
                                    defaultFilters = {
                                        isOwned: false,
                                        isConnected: true,
                                        isResellerNetwork: true,
                                        isReceived: true
                                    }
                                }

                                tableActions.updateDefaultFilter(defaultFilters);
                                initHandlers(tableActions);
                                tableActions.sendRequest();
                            },
                            trueLabel: 'MY SERVICE PROFILES',
                            falseLabel: 'NETWORK SERVICE PROFILES',
                        }
                        tableStructure.optionAddOns.wrapperClass = ''
                        tableStructure.optionAddOns.url = '/templates/pages/carriers/additionals/clientDropdown.html'
                    }

                }, error => { }, $rootScope.GlobalProfile.id);
            }

            const originalTable = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getServiceProfiles,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc',
                        isOwned: true
                    }
                }
            );

            let tableActions = originalTable;
            let sort = null;
            let evaluateFilter = null;
            let resetFilters = null;
            let sendRequest = null;

            initHandlers(tableActions);

            function initHandlers(actions) {
                sort = actions.sort;
                evaluateFilter = actions.evaluateFilter;
                resetFilters = actions.resetFilters;
                sendRequest = actions.sendRequest;
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    row.button = {
                        type: 'button',
                        buttons: [{
                            text: 'View / Edit',
                            class: 'btn btn-primary',
                            action: function () {
                                /* fixme */
                            }
                        }]
                    };
                    row.name = angular.getObjVal(row, 'displayName') ? row.displayName : row.name;
                    const currency = $rootScope.GlobalProfile.office.currency || 'AUD';
                    row.currentFuelLevy = angular.getObjVal(row, 'fuelLevy.details') ?
                        angular.getObjVal(row, 'fuelLevy.details.name') : 'N/A';

                    row.marginFixed = angular.getObjVal(row, 'fuelLevy.details') && angular.getObjVal(row, 'fuelLevy.details.fixed') !== null ?
                        $filter('bbaCurrency')(angular.getObjVal(row, 'fuelLevy.details.fixed'), currency) : `0.00 ${currency}`;

                    row.marginPercent = angular.getObjVal(row, 'fuelLevy.details') && angular.getObjVal(row, 'fuelLevy.details.percentage') !== null ?
                        angular.getObjVal(row, 'fuelLevy.details.percentage') + ' %' : '0 %';
                    row.serviceName = angular.getObjVal(row, 'service.name') || 'N/A';
                    row.carrierProfileName = angular.getObjVal(row, 'carrierProfile.name') || 'N/A';
                    row.carrierCode = row.carrierAccountCode || 'N/A';
                    row.status = row.status = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Enabled' : 'Disabled'
                    };
                    row.networkEffect = {
                        type: 'status',
                        status: row.networkEffectEnabled,
                        label: row.networkEffectEnabled ? 'Enabled' : 'Disabled'
                    };
                    row.href = row.bbaProfileId ?
                        '/bba-profile-manager/' + row.bbaProfileId :
                        '/carriers/service-profiles/' + row.id;
                    /*row.href = !row.detailHidden ? '/carriers/service-profiles/' + row.id : '';
                    row.tooltip = row.detailHidden ? 'Detailed view disabled' : null;
                    row.disabled = row.detailHidden;*/

                    tableStructure.data.push(row);
                });
            };
            this.tableData = tableStructure;
        };
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ServiceProfileTableService.js